<div
  class="innerBanner"
  (click)="imageClick(0)"
  style="background-image: url('../../../assets/images/banner-accommodation.avif')"
>
  <div class="bannerText">
    <h1>{{ 'Search Result' | translate }}</h1>
  </div>
</div>

<p-galleria
  [(value)]="images"
  [(visible)]="displayCustom"
  [(activeIndex)]="activeIndex"
  [fullScreen]="true"
  [showItemNavigators]="false"
  [baseZIndex]="100000"
  [containerStyle]="{ 'max-width': '90%' }"
>
  <ng-template pTemplate="item" let-item>
    <img [src]="item" class="gallery-image" />
  </ng-template>
</p-galleria>
<!-- <nav aria-label="breadcrumb">
  <ol class="breadcrumb">
  <li class="breadcrumb-item"><a href="/home">Home</a></li>
  <li class="breadcrumb-item active" aria-current="page">Search Result</li>
  </ol>
  </nav> -->
<!-- <app-breadcrumb></app-breadcrumb> -->
<app-breadcrumb-row></app-breadcrumb-row>
<div class="container-fluid searchResultSection pt-3 pb-3">
  <span class="filterMobile noDesktop" (click)="searchToggle()"
    ><a href="javascript:;" class="filterBtn"><i class="icon icon-sliders"></i> {{ 'Filters' | translate }}</a></span
  >
  <div class="row">
    <div class="col-md-4 col-lg-3 searchToggle" id="SearchToggle">
      <h2 class="closeFilter"><i class="icon icon-sliders"></i> {{ 'Filter Results' | translate }}</h2>
      <div class="closeFilter" (click)="searchToggle()">X</div>
      <!-- <div> -->
      <!-- <p-autoComplete
  placeholder="Search"
  [suggestions]="newserachResults"
  (completeMethod)="search($event)"
  minLength="3"
  (onSelect)="getSearchDetails($event)"
  [(ngModel)]="textEnter"
  ></p-autoComplete> -->
      <!-- <p class="nearByLbl mb-1"><i class="icon-direction"></i>Near by</p> -->
      <!-- </div> -->
      <!-- <div class="mb-3">
  <div *ngFor="let neariland of nearByIslands; let i = index" class="btn-group">
  <button
  pButton
  type="button"
  label="{{ neariland.name }}"
  class="p-button-rounded p-button-outlined mb-2 mr-2"
  (click)="selectNearIlands(neariland.id, neariland.isClassification)"
  ></button>
  </div>
  </div> -->
      <p-accordion class="categoryList">
        <p-accordionTab header="{{ 'Search-Category' | translate }}">
          <!-- <a href="javascript:void(0)" (click)="clearCategory()">clear selction</a>
  <ul>
  <li *ngFor="let category of categoryTypes; let i = index">
  <p-checkbox class="pcheck" [(ngModel)]="selectedCategory" (click)="selectCategeory(category)"> </p-checkbox
  ><span>{{ category.name }}</span>
  </li>
  </ul> -->
          <span class="Select">{{ 'Search-Select-All' | translate }}</span>
          <a href="javascript:void(0)" (click)="clearCategory()" class="clearSelection">{{
            'clear selection' | translate
          }}</a>
          <div>
            <p-listbox
              [options]="categoryTypes"
              multiple="multiple"
              checkbox="checkbox"
              filter="filter"
              name="select All"
              optionLabel="name"
              [(ngModel)]="selectedCategory"
              (onChange)="selectCategeory(selectedCategory)"
              class="selectall"
            ></p-listbox>
          </div>
        </p-accordionTab>
      </p-accordion>
      <p-accordion class="mb-3">
        <p-accordionTab header="{{ 'Search-SelectIsland' | translate }}"
          ><span class="Select">{{ 'Search-Select-All' | translate }}</span>
          <a href="javascript:void(0)" (click)="clearIsLand()" class="clearSelection">{{
            'clear selection' | translate
          }}</a>
          <div>
            <p-listbox
              [options]="isLandTypes"
              multiple="multiple"
              checkbox="checkbox"
              filter="filter"
              name="select All"
              optionLabel="name"
              [(ngModel)]="selectedIslands"
              (onChange)="selectIsLand(selectedIslands)"
              class="selectall"
            ></p-listbox>
            <!-- <span *ngFor="let c of isLandTypes" style="margin-right: 10px">{{c.name}}</span></p> -->
            <!-- <tr *ngFor="let island of isLandTypes; let i = index">
  <td>
  <p-checkbox class="pcheck" (click)="selectIsLand(island.name)"></p-checkbox
  ><span>{{ island.name }}</span>
  </td>
  </tr> -->
            <!-- <a (click)="moreIslands()" *ngIf="moreIsland">More</a> -->
          </div>
        </p-accordionTab>
        <!-- <div class="text-center">
  <a href="javascript:void(0);" class="btn btn-outline-primary btn-lg" (click)="clearIsLands()">Clear Filters</a>
  </div> -->
      </p-accordion>
      <p-accordion>
        <p-accordionTab header="{{ 'Search-Facilities' | translate }}">
          <span class="Select">{{ 'Search-Select-All' | translate }}</span>
          <a href="javascript:void(0)" (click)="clearAmentments()" class="clearSelection">{{
            'clear selection' | translate
          }}</a>
          <div>
            <p-listbox
              [options]="amentisTypes"
              multiple="multiple"
              checkbox="checkbox"
              filter="filter"
              optionLabel="Description"
              [(ngModel)]="selectedFacilities"
              (onChange)="selectAmentments(selectedFacilities)"
              class="selectall"
            ></p-listbox>
            <!-- <tr *ngFor="let aments of amentisTypes; let i = index">
  <td>
  <p-checkbox class="pcheck" (click)="selectAmentments(aments.name)"></p-checkbox
  ><span>{{ aments.name }}</span>
  </td>
  </tr> -->
            <!-- <a (click)="moreAmmentments()" *ngIf="moreAmendments">More</a> -->
          </div>
        </p-accordionTab>
      </p-accordion>
      <!-- <div><input type="radio" name="selectedCountry" /><b class="ml-1">Seychelles</b></div>
  <div></div>
  <input type="radio" name="selectedCountry" /><b class="ml-1">Other then seychelles</b> -->
    </div>
    <div class="col-md-12 col-lg-9" *ngIf="searchResults">
      <div class="card">
        <div class="p-mb-3">
          <!-- <p-button type="button" icon="pi pi-chevron-left" (click)="prev()" [disabled]="isFirstPage()" styleClass="p-button-text"></p-button>
  <p-button type="button" icon="pi pi-refresh" (click)="reset()" styleClass="p-button-text"></p-button>
  <p-button type="button" icon="pi pi-chevron-right" (click)="next()" [disabled]="isLastPage()" styleClass="p-button-text"></p-button> -->
        </div>
        <!-- [paginator]="true" -->
        <!-- [rowsPerPageOptions]="[10]" -->
        <!-- [(first)]="first" -->
        <b
          ><span style="color: crimson">{{ totalRecords }} </span>{{ 'Results were found' | translate }}</b
        >
        <p-table
          [value]="searchResults"
          [rows]="rows"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        >
          <!--<ng-template pTemplate="header">
  <tr>
  <th></th>
  <th></th>
  </tr>
  </ng-template>-->
          <ng-template pTemplate="body" let-product>
            <tr>
              <td>
                <img
                  [src]="product.productImage ? product.productImage : '../../../assets/images/NoImage.jpg'"
                  width="100"
                  height="120"
                />
              </td>
              <td>
                <h5>{{ product.productName }}</h5>
                <p>
                  {{ product.productDescription }}
                  <a href="javascript:void(0)" class="p-button-text" (click)="viewMoreDetils(product.productId)">{{
                    'View Details' | translate
                  }}</a>
                </p>
                <h6>
                  <i class="icon-location"></i>{{ product.addresses[0].islandArea
                  }}<span *ngIf="product.island && product.addresses[0].islandArea">,&nbsp;</span>{{ product.island }}
                  <!-- <span class="price"
  >{{ product.currency }} {{ product.rateFrom }} - {{ product.currency }} {{ product.rateTo }}</span
  > -->
                </h6>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <p *ngIf="isViewMoreRecords">
          <a (click)="ViewMoreRecord()" class="p-button p-button-rounded p-button-outlined">{{
            'View More' | translate
          }}</a>
        </p>
      </div>
    </div>
  </div>
</div>
